module.exports = __webpack_public_path__ + "img/angle-up.cf26fb73.svg";